import request from '@/router/axios';

function toBladePageParams(params) {
  const p = { ...params };
  if (p.page != null) {
    p.current = p.page;
    delete p.page;
  }
  return p;
}

export const getList = (params) => request({
  url: '/api/produce/contract-settlement-bill/page',
  method: 'get',
  params: toBladePageParams(params),
});

export const getDetail = (id) => request({
  url: '/api/produce/contract-settlement-bill/detail',
  method: 'get',
  params: { id },
});

export const generateBill = (data) => request({
  url: '/api/produce/contract-settlement-bill/generate',
  method: 'post',
  data,
});

export const batchGenerateBill = (data) => request({
  url: '/api/produce/contract-settlement-bill/batch-generate',
  method: 'post',
  data,
});

export const adjustItem = (data) => request({
  url: '/api/produce/contract-settlement-bill/item/adjust',
  method: 'post',
  data,
});

export const manualFillItem = (data) => request({
  url: '/api/produce/contract-settlement-bill/item/manual-fill',
  method: 'post',
  data,
});

export const submitBill = (data) => request({
  url: '/api/produce/contract-settlement-bill/submit',
  method: 'post',
  data,
});

export const cancelBill = (data) => request({
  url: '/api/produce/contract-settlement-bill/cancel',
  method: 'post',
  data,
});

export const exportExcel = (data) => request({
  url: '/api/produce/contract-settlement-bill/export',
  method: 'post',
  data,
  responseType: 'blob',
});
